import imageLayer from "@/assets/background-image.jpg";
import { Autoplay, FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useGetHomePageSponsorshipCommunityQuery } from "../../utils/API/features/strapiHomeApi";
import { CustomLoaderType } from "../../utils/constants";
import CustomLoader from "../Shared/CustomLoader/CustomLoader";
import "./StrongerCommunity.scss";
import PropTypes from "prop-types";

const StrongerCommunity = ({ logosOnly }) => {
	const shouldUseStrapi = Boolean(import.meta.env.VITE_STRAPI_URL);
	const {
		data: strapiLogos = [],
		isLoading,
		isFetching,
		isError,
	} = useGetHomePageSponsorshipCommunityQuery(undefined, {
		skip: !shouldUseStrapi,
	});

	const isBusy = shouldUseStrapi && (isLoading || isFetching);
	const logos = !isBusy && !isError && strapiLogos.length > 0 ? strapiLogos.map((l) => ({ name: l.name, image: l.src })) : [];

	if (!isBusy && logos.length === 0) return null;
	return (
		<div className='stronger-community-wrapper'>
			<div className='top-header'>
				<p>Sponsorship & Community Involvement</p>
				<h1>Supporting Local Teams and Events for a Stronger Community</h1>
			</div>
			<div className='logo-wrapper-mobile'>
				<Swiper
					slidesPerView={"auto"}
					spaceBetween={10}
					autoplay={{
						delay: 0,
						disableOnInteraction: true,
					}}
					freeMode={true}
					loop={true}
					speed={3000}
					modules={[Autoplay, FreeMode]}
					className={`mySwiper`}
				>
					{isBusy ? (
						<SwiperSlide>
							<CustomLoader type={CustomLoaderType.SMALL} />
						</SwiperSlide>
					) : (
						logos.map((logo, index) => (
							<SwiperSlide key={index}>
								<div className='logo'>
									<img src={logo.image} alt='logo' />
									<p>{logo.name}</p>
								</div>
							</SwiperSlide>
						))
					)}
				</Swiper>
			</div>
			{!logosOnly && (
				<div className='image-part'>
					<img src={imageLayer} alt='team' />
					<div className='text-part'>
						<h3>Annual Employee Golf Day</h3>
					</div>
				</div>
			)}
		</div>
	);
};

export default StrongerCommunity;

StrongerCommunity.propTypes = {
	logosOnly: PropTypes.bool,
};
